import {
  IGetFeedbackForUserResponse,
  ISkipFeedbackPayload,
  ISkipFeedbackResponse,
  ISubmitFeedbackBadRequestResponse,
  ISubmitFeedbackUnauthorizedResponse,
  ISubmitFeedbackWithCommentPayload,
  ISubmitFeedbackWithCommentResponse,
  ISubmitRatingPayload,
  ISubmitRatingResponse
} from "./npsService.types";
import wretch from "wretch";
import { generateUUID } from "utils/utils";

const BASE_URL = `${process.env.NEXT_PUBLIC_LIVE_CLASSES_BASE_URL}`;

export const getUserFeedback = (
  access_token: string
): Promise<IGetFeedbackForUserResponse> => {
  return wretch(`${BASE_URL}/api/v1/live_classes/pending_feedback`)
    .headers({ "X-IQ-Locale": "id", "x-iq-request-id": generateUUID() })
    .auth(`Bearer ${access_token}`)
    .get()
    .json();
};

export const submitNpsRating = (
  payload: ISubmitRatingPayload,
  access_token: string
): Promise<
  | ISubmitRatingResponse
  | ISubmitFeedbackUnauthorizedResponse
  | ISubmitFeedbackBadRequestResponse
> => {
  return wretch(`${BASE_URL}/api/v1/feedback`)
    .headers({ "X-IQ-Locale": "id", "x-iq-request-id": generateUUID() })
    .auth(`Bearer ${access_token}`)
    .post(payload)
    .json();
};

export const skipNpsFeedback = (
  payload: ISkipFeedbackPayload,
  access_token: string
): Promise<ISkipFeedbackResponse> => {
  return wretch(`${BASE_URL}/api/v1/feedback`)
    .headers({ "X-IQ-Locale": "id", "x-iq-request-id": generateUUID() })
    .auth(`Bearer ${access_token}`)
    .post(payload)
    .json();
};

export const updateNpsFeedback = (
  payload: ISubmitFeedbackWithCommentPayload,
  id: string,
  access_token: string
): Promise<ISubmitFeedbackWithCommentResponse> => {
  return wretch(`${BASE_URL}/api/v1/feedback/${id}`)
    .headers({ "X-IQ-Locale": "id", "x-iq-request-id": generateUUID() })
    .auth(`Bearer ${access_token}`)
    .put(payload)
    .json();
};
